import { TweenMax, Power1 } from 'gsap'
import React, { Component } from 'react'
import './index.scss'

class Loader extends Component {
  constructor () {
    super()
    this.dotWrap = null
    this.dotWrap2 = null
    this.dotWrap3 = null
    this.dotWrap4 = null
    this.dotWrap5 = null
    this.dotWrap6 = null
    this.dotTween = null
    this.dotTween2 = null
    this.dotTween3 = null
    this.dotTween4 = null
    this.dotTween5 = null
    this.dotTween6 = null
  }

  componentDidMount () {
    this.dotTween = TweenMax.fromTo(this.dotWrap, 0.5, { y: +40 }, {
      y: -40, ease: Power1.easeInOut, yoyo: true, repeat: -1, repeatDelay: 0,
    })
    this.dotTween2 = TweenMax.fromTo(this.dotWrap2, 0.5, { y: +40 }, {
      y: -40, ease: Power1.easeInOut, yoyo: true, repeat: -1, delay: 0.2, repeatDelay: 0,
    })
    this.dotTween3 = TweenMax.fromTo(this.dotWrap3, 0.5, { y: +40 }, {
      y: -40, ease: Power1.easeInOut, yoyo: true, repeat: -1, delay: 0.4, repeatDelay: 0,
    })
    this.dotTween4 = TweenMax.fromTo(this.dotWrap4, 0.5, { y: +40 }, {
      y: -40, ease: Power1.easeInOut, yoyo: true, repeat: -1, delay: 0.6, repeatDelay: 0,
    })
    this.dotTween5 = TweenMax.fromTo(this.dotWrap5, 0.5, { y: +40 }, {
      y: -40, ease: Power1.easeInOut, yoyo: true, repeat: -1, delay: 0.8, repeatDelay: 0,
    })
    this.dotTween6 = TweenMax.fromTo(this.dotWrap6, 0.5, { y: +40 }, {
      y: -40, ease: Power1.easeInOut, yoyo: true, repeat: -1, delay: 1, repeatDelay: 0,
    })
  }

  render () {
    return (
      <div className="loader">
        <div className="loader__content">
          <div className="loader__item" ref={(div) => { this.dotWrap = div } } />
          <div className="loader__item" ref={(div) => { this.dotWrap2 = div } } />
          <div className="loader__item" ref={(div) => { this.dotWrap3 = div } } />
          <div className="loader__item" ref={(div) => { this.dotWrap4 = div } } />
          <div className="loader__item" ref={(div) => { this.dotWrap5 = div } } />
          <div className="loader__item" ref={(div) => { this.dotWrap6 = div } } />
        </div>
      </div>
    )
  }
}

export default Loader
